import { LEAD_SOURCE_OPTIONS } from './lead-field-options.util';

export const CRM_LEAD_SOURCE_NAMES = [
  'HubSpot',
  'Zoho CRM',
  'Freshdesk',
  'Freshsales',
  'Freshworks CRM',
] as const;

export function isCrmLeadSource(source: unknown): boolean {
  const value = String(source || '')
    .trim()
    .toLowerCase();
  if (!value) return false;
  return CRM_LEAD_SOURCE_NAMES.some((name) => name.toLowerCase() === value);
}

export function findPipelineByName(pipelines: any[] | null | undefined, name: unknown) {
  const needle = String(name || '')
    .trim()
    .toLowerCase();
  if (!needle) return null;
  return (
    (pipelines || []).find(
      (pipeline) => String(pipeline?.pipeline_name || '').trim().toLowerCase() === needle
    ) || null
  );
}

export function findPipelineById(pipelines: any[] | null | undefined, pipelineId: unknown) {
  if (pipelineId == null || pipelineId === '') return null;
  return (
    (pipelines || []).find((pipeline) => String(pipeline?.pipeline_id) === String(pipelineId)) ||
    null
  );
}

export function applyCrmSourcePipeline(
  editFieldValues: any,
  pipelines: any[] | null | undefined
): boolean {
  if (!editFieldValues || !isCrmLeadSource(editFieldValues.lead_source)) {
    return false;
  }
  const pipeline = findPipelineByName(pipelines, editFieldValues.lead_source);
  if (!pipeline) return false;
  editFieldValues.pipeline_id = pipeline.pipeline_id;
  return true;
}

export function pipelineStageLabel(
  stage: { stage_name?: string; probability?: number } | null | undefined
): string {
  const name = String(stage?.stage_name || '').trim();
  if (stage?.probability == null || String(stage.probability).trim() === '') {
    return name;
  }
  const pct = Number(stage.probability);
  if (!Number.isFinite(pct)) return name;
  return `${name} (${pct}%)`;
}

export function leadSourceSelectOptions(current: unknown): string[] {
  const value = String(current || '').trim();
  if (value && !LEAD_SOURCE_OPTIONS.includes(value)) {
    return [value, ...LEAD_SOURCE_OPTIONS];
  }
  return [...LEAD_SOURCE_OPTIONS];
}
